export default "/images/4d67288f24d74cf82906c8d1dbc82a21.avif";